<div class="card">
	<div class="card-header">
		<h3>
			Clear System Data
		</h3>
	</div>
	<div class="card-body" *ngIf="cleared == false">
		<div class="alert alert-warning" *ngIf="message && !clearing">{{message}}</div>

		<!-- Progress bar -->
		<div *ngIf="clearing" class="mb-3">
			<div class="alert alert-info">{{message || 'Processing...'}}</div>
			<div class="progress" style="height: 25px;">
				<div
					class="progress-bar progress-bar-striped progress-bar-animated bg-danger"
					role="progressbar"
					[style.width.%]="progress"
					[attr.aria-valuenow]="progress"
					aria-valuemin="0"
					aria-valuemax="100">
					{{progress | number:'1.0-0'}}%
				</div>
			</div>
		</div>

		<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="container mt-4" *ngIf="!clearing">
			<div class="row">
				<div class="col">
					<div class="mb-3">
						<label for="otp" class="form-label">OTP</label>
						<input type="input" id="otp" class="form-control" formControlName="otp"
							[class.is-invalid]="getFormControl('otp').invalid && getFormControl('otp').touched"
							placeholder="Clear All System Data OTP" />
						<div *ngIf="getFormControl('otp').errors && getFormControl('otp').touched" class="invalid-feedback">
							<div *ngIf="controlInvalid('otp')" class="text-danger">{{ getError('otp') }}</div>
						</div>
					</div>
				</div>
			</div>
			<button type="submit" class="btn btn-danger" [disabled]="formGroup.invalid">Clear all system data</button>
		</form>
	</div>
	<div class="card-body" *ngIf="cleared == true">
		<div class="alert alert-info">System data cleared</div>
	</div>
</div>
